import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CardModel } from '../../models/card.model';
import { PaginaCardsModel } from '../../models/pagina-cards.model';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

  @Input() cardsList = new Array<PaginaCardsModel>();
  @Output() eventoPegarCard = new EventEmitter<CardModel>();


  @Input() disabled: Boolean;

  constructor(
  ) { }

  ngOnInit() {

  }

  pegandoCard(card: CardModel): void {
    this.eventoPegarCard.emit(card);
  }
}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/card/card.component.ts